import React, { Component } from "react";
import Footer from "./footer";
import "../styles/layout/layout.scss";
import { connect } from "react-redux";
import loader from "../static/images/loader.gif";
import { setLoadingPage, setErrorMessage } from "../reducers/actions";
import { Button, Modal } from "react-bootstrap";

class Layout extends Component {

  constructor(props) {
    super(props);
    this.state = {
      boolean: false,
      modalOpen: false,
    };
  }

  handleClose = () => {
    this.setState({ modalOpen: false });
    this.props.setErrorMessageAction("");
  };

  render() {
    let realTime = "";
    if (this.props.customGroups) {
      realTime = "realTimeLoader";
    }

    return (
      <div className="pageBody">
        <div>
          <div
            className={
              this.props.loading ? `loader ${realTime}` : `hide ${realTime}`
            }
          >
            <img src={loader} height="100px" weight="100px" alt="" />
          </div>
          {this.props.children}
          <Footer />
        </div>
        {this.props.errorMessage == "" ? (
          ""
        ) : (
          <div className="errorBox">
            <Modal
              show={this.props.errorMessage !== "" ? true : false}
              onHide={this.handleClose}
            >
              <Modal.Header closeButton>
                <Modal.Title>Error</Modal.Title>
              </Modal.Header>
              <Modal.Body>{this.props.errorMessage}</Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={this.handleClose}>
                  Close
                </Button>
              </Modal.Footer>
            </Modal>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: state.loading,
  errorMessage: state.errorMessage,
});
const mapDispatchToProps = {
  setLoadingPageAction: setLoadingPage,
  setErrorMessageAction: setErrorMessage,
};
export default connect(mapStateToProps, mapDispatchToProps)(Layout);
